export default {"src":"/_next/static/media/404.cba46e51.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};